module.exports = __webpack_public_path__ + "img/czleader10.959ec768.png";